const userReducer = (state, action) => {
  switch (action.type) {
    case 'CURRENT_USER':
      return action.payload;
    case 'UPDATE':
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export { userReducer as default };
